import { useAuth } from '@/app/context';
import { UserGroup } from '@/shared/utils/get-group';
import { useEffect, useState } from 'react';

/**
 * Estornar uma cobrança paga no cartão: só a administração da seguradora e o
 * financeiro — o mesmo `@RequireGroups` do backend.
 *
 * Esconder o botão é conveniência, não segurança: a API recusa a chamada direta
 * de quem não está nesses grupos.
 */
export function useCanRefundPaymentCharges() {
  const { checkUserGroups } = useAuth();
  const [canRefund, setCanRefund] = useState<boolean | null>(null);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    const check = async () => {
      setIsLoading(true);
      const result = await checkUserGroups([
        UserGroup.INSURER_ADMINISTRATOR,
        UserGroup.INSURER_FINANCE,
      ]);
      setCanRefund(result);
      setIsLoading(false);
    };

    check();
  }, [checkUserGroups]);

  return { canRefund, isLoading };
}
